'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditListPlugin = require('../plugins/EditListPlugin');

var _EditListPlugin2 = _interopRequireDefault(_EditListPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unwrapList = _EditListPlugin2.default.changes.unwrapList;


var ClearStrategy = function ClearStrategy(value, mark) {
  return unwrapList(value.change().unwrapBlock('heading-one').unwrapBlock('heading-two').setBlock('paragraph'));
};

exports.default = ClearStrategy;